angular.module('moebiusProadapt').controller('ctrlParticipantTraitement',
    ['$rootScope', '$scope', '$http', 'moment', '$timeout', '$location', '$controller', 'mbsEtiService', 'mbsParticipantService', '$uibModal','eti','questionVisite','participant','questionMere','linkedObject',
        function ($rootScope, $scope, $http, moment, $timeout, $location, $controller, mbsEtiService, mbsParticipantService, $uibModal, eti, questionVisite, participant, questionMere,linkedObject) {

            $scope.traitement   = linkedObject;
            $scope.traitement.medicalReasonList = [];
            $scope.traitement.medical_reason_textarea = "";

            console.log('traitement received', $scope.traitement );

            $scope.therapeutic_modif_reason_list = [];
            _.each($rootScope.constants.modif_therapeutiques_types.VALUES_TO_DISPLAY,function(value,key){
                $scope.therapeutic_modif_reason_list.push({id:parseInt(key),label:value});
            });

            $scope.title        = questionMere.name;
            $scope.titleConfirm = 'OK';

            if ($scope.traitement.editOrSave === 'SAVE') {
                $scope.title        = $scope.title + '-' + 'Ajout';
                $scope.titleConfirm = 'Ajouter';

            } else {
                $scope.title        = $scope.title + '-' + 'Edition';
                $scope.titleConfirm = 'Modifier';
            }

            $scope.choicesPosologie = [
                {name:'0', value:'0'},
                {name:'1/2', value:'1/2'},
                {name:'1', value:'1'},
                {name:'2', value:'2'}
            ];
            $scope.choicesVoieAdministration = [];
            _.each($rootScope.constants.voie_administration_traitement_list.VALUES_TO_DISPLAY,function(value,key){
                $scope.choicesVoieAdministration.push({name:key,value:value});
            });

            // -- init
            if ($scope.traitement.dose === "ND") {
                $scope.traitement.is_dose_nd = 1;
            }

            if (!$scope.traitement.posologie_matin) {
                $scope.traitement.posologie_matin = '';
            } else if($scope.traitement.posologie_matin === "ND") {
                $scope.traitement.is_posologie_nd = 1 ;
            }
            if (!$scope.traitement.posologie_midi) {
                $scope.traitement.posologie_midi = '';
            }
            if (!$scope.traitement.posologie_soir) {
                $scope.traitement.posologie_soir = '';
            }
            if (!$scope.traitement.voie_administration) {
                $scope.traitement.voie_administration = '';
            }

            if($scope.traitement.posologie_matin === "ND" ||$scope.traitement.posologie_midi === "ND" || $scope.traitement.posologie_soir === "ND") {
                $scope.traitement.is_posologie_nd = 1 ;
            }

            if ($scope.traitement.date_debut) {
                $scope.traitement.date_debut = moment($scope.traitement.date_debut).hour(12).toDate();
            }
            if ($scope.traitement.date_fin) {
                $scope.traitement.date_fin = moment($scope.traitement.date_fin).hour(12).toDate();
            }
            if ($scope.traitement.modifications_therapeutiques_date_changement) {
                $scope.traitement.modifications_therapeutiques_date_changement = moment($scope.traitement.modifications_therapeutiques_date_changement).hour(12).toDate();
            }

            // Any function returning a promise object can be used to load values asynchronously
            $scope.getTraitement = function(val) {
                return $http.post('participant-traitement/search-libelle-theriaque', {search_nom_specialite_medicamenteuse: val})
                    .then(function(response){
                        return response.data;
                        // return response.data.map(function(item){
                    //     return item.libelle_theriaque;
                    // });
                });
            };

            $scope.selectTraitement = function($item, $model, $label, $event) {
                console.log('-------- SELECTED TRAITEMENT');
                if ($item) {
                    $scope.traitement.traitement_id = $item.id;
                    $scope.traitement.atc_specialite_medicamenteuse = $item.atc;
                    $scope.traitement.ucd13_specialite_medicamenteuse = $item.ucd13;
                    return $http.post('participant-traitement/search-medical-reason', {traitement_id: $item.id})
                                .then(function(response){
                                    //on remplit la liste des causes de traitement
                                    $scope.traitement.medicalReasonList = response.data;
                                });
                } else {
                    // $scope.traitement.traitement_id                     = null;
                    // $scope.traitement.atc_specialite_medicamenteuse     = null;
                    // $scope.traitement.ucd13_specialite_medicamenteuse   = null;
                }
                console.log('$item',$item);
                console.log('$model', $model);
                console.log('$label', $label);
                console.log('$event', $event);
            };

            $scope.emptyPosologieIfNC = function() {
                if($scope.traitement.is_posologie_nd === 1) {
                    $scope.traitement.posologie_matin = "ND" ;
                    $scope.traitement.posologie_midi = "ND" ;
                    $scope.traitement.posologie_soir = "ND" ;
                    $scope.traitement.is_pnr = null ;
                }
            };

       /**
         * *************************************************************************************************
         * ********************* Initialization
         * *************************************************************************************************
         */
        //
        // /**
        //  * setup the controller
        //  */
        // var initialize = function () {
        // };
        //
        // initialize();
    }]
);



// WEBPACK FOOTER //
// ./resources/assets/js/controllers/etude/participantTraitement.js